import { Injectable } from '@angular/core';
import { APIProviderService } from '../api/api.provider.service';
import { GemstoneType } from 'src/app/interfaces/gemstone-type';

@Injectable({
  providedIn: 'root'
})
export class StoneTypesProviderService extends APIProviderService<GemstoneType> {
  protected override get attributeURL(): string {
    return `${super.attributeURL}/Gemstones/Types`;
  }
}
